import { Link } from 'react-router-dom'
import { BRAND_TAGLINE } from '../constants/brand.js'
import { LOGOS } from '../pages/home/constants/photos.js'

const COLUMNS = [
  {
    title: 'Services',
    links: [
      { to: '/weight-loss', label: 'Weight Loss' },
      { to: '/womens-hormones', label: "Women's Hormones" },
      { to: '/mens-health', label: "Men's Hormones" },
      { to: '/peptides', label: 'Peptides' },
      { to: '/wellness', label: 'Wellness' },
      { to: '/labs', label: 'Labs' },
      { to: '/products', label: 'All Products' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About HealBerry' },
      { to: '/providers', label: 'Our Providers' },
      { to: '/pricing', label: 'Pricing' },
      { to: '/blog', label: 'Learn' },
    ],
  },
  {
    title: 'Support',
    links: [
      { to: '/intake', label: 'Get Started' },
      { to: '/contact', label: 'Contact' },
      { to: '/faq', label: 'FAQ' },
      { to: '/privacy', label: 'Privacy' },
      { to: '/terms', label: 'Terms' },
    ],
  },
]

export function Footer() {
  return (
    <footer className="bg-[#191A17] pb-10 pt-14 text-white sm:pt-16">
      <div className="mx-auto w-full max-w-[1400px] px-5 sm:px-8 lg:px-10">
        <div className="mb-10 grid gap-10 sm:mb-12 sm:gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-8 xl:gap-12">
          <div className="max-w-none lg:max-w-[340px]">
            <img src={LOGOS.nameWhite} alt="HealBerry" width={520} height={71} loading="lazy" className="mb-4 w-[180px] sm:w-[210px]" />
            <p className="font-sans text-[14px] font-normal leading-[1.7] text-white/80 sm:text-[15px]">
              {BRAND_TAGLINE}
            </p>
            <a
              href="mailto:hello@healberry.com"
              className="mt-4 inline-block font-display text-[15px] font-extrabold text-white transition hover:text-lagoon sm:text-[16px]"
            >
              hello@healberry.com
            </a>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="mb-4 font-display text-[12px] font-extrabold uppercase tracking-[1.5px] text-white sm:mb-[18px] sm:text-[12.5px]">
                {col.title}
              </div>
              <ul className="flex flex-col gap-2.5 sm:gap-[11px]">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="font-sans text-[14px] font-medium text-white/75 transition hover:text-lagoon"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/15 pt-6 sm:pt-7">
          <div className="mb-5 flex flex-wrap gap-2.5 sm:gap-3.5">
            {['503A Pharmacy Standard', 'Licensed Practitioners Only', 'Licensed in All 50 States', 'HIPAA Aligned'].map(
              (badge) => (
                <span
                  key={badge}
                  className="rounded-lg border border-white/20 bg-white/10 px-3 py-2 font-display text-[11px] font-bold text-white sm:px-[15px] sm:text-[12px]"
                >
                  {badge}
                </span>
              ),
            )}
          </div>
          <p className="max-w-[1100px] font-sans text-[11px] font-normal leading-[1.8] text-white/55 sm:text-[12px]">
            HealBerry is not a pharmacy and does not dispense medications. All prescriptions are
            issued by licensed healthcare practitioners following clinical evaluation. Medications
            are compounded by independent 503A-compliant pharmacies. HealBerry does not prescribe or
            dispense products labeled &quot;for research use only.&quot; Results may vary. This
            website is for informational purposes only and does not constitute medical advice,
            diagnosis, or treatment. Always consult a qualified healthcare provider. © 2026
            HealBerry. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
